import { createBasicSelect } from "@/components/form"
import { anyProp, defineComponent, EnumSchema, requiredProp, type Component, type ReactiveComponent } from "vue-utils"
import type { GenericInputProps } from "./InputComponent"

export function createEnumInput<T extends string>(schema: EnumSchema<T>): Component<GenericInputProps<T>> {
	type Props = GenericInputProps<T>

	const EnumSelect = createBasicSelect<T>()

	const EnumInput: ReactiveComponent<Props> = (props) => {
		return () => (
			<EnumSelect options={Object.values(schema.enumValues)} value={props.value} setValue={props.setValue} required />
		)
	}

	return defineComponent(EnumInput, {
		value: anyProp(),
		setValue: requiredProp(Function),
	})
}
